<page-header style="background-color: #005595" [title]="'Laboratory User Menu'"></page-header>
<h1 *ngIf="!activeUser && loaded">Please contact your administrator for laboratory access approval.</h1>
<mat-card *ngIf="loaded && activeUser">
  <mat-card-header>
    <mat-card-title>
      Registered Labs
      <button class="matero-toolbar-button"
              (click)="downloadHelpFile()"
              aria-label="Application Help"
              matTooltip="Help"
              matTooltipPosition="right">
        <mat-icon class="dark-theme-icon">help_outline</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="flex flex-col" *ngIf="labs.length !== 1">
      <div class="flex flex-row">
        <mat-form-field>
          <input matInput
                 id="labsFilter"
                 (keyup)="filterTable($event.target.value)"
                 placeholder="Filter"
                 value="{{this.service.labFilter}}"/>
        </mat-form-field>
      </div>

      <div style="overflow-x:auto">
        <div class="flex flex-row">
          <table mat-table
                 [dataSource]="dataSource" multiTemplateDataRows
                 matSort
                 #ApplicationSort="matSort"
                 class="mat-elevation-z8 w-full">
            <ng-container matColumnDef="orelapId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>ORELAP</th>
              <td mat-cell *matCellDef="let lab">{{lab.orelapId}}</td>
            </ng-container>
            <ng-container matColumnDef="laboratoryName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Laboratory Name</th>
              <td mat-cell *matCellDef="let lab">{{lab.laboratoryName}}</td>
            </ng-container>
            <ng-container matColumnDef="primaryAa">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Primary AA</th>
              <td mat-cell *matCellDef="let lab">{{lab.primaryAa}}</td>
            </ng-container>
            <ng-container matColumnDef="accreditationType">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Accreditation Type</th>
              <td mat-cell *matCellDef="let lab">{{lab.accreditationType}}</td>
            </ng-container>

            <ng-container matColumnDef="expandedDetail">
              <td mat-cell *matCellDef="let lab" [attr.colspan]="displayedColumns.length" class="p-l-0">
                <div class="expansion-element-detail" [@detailExpand]="(lab != null && expandedElement != null && lab.orelapId == selectedLab) ? 'expanded' : 'collapsed'">
                  <div class="expansion-element-diagram">
                    <app-lab-applications *ngIf="lab.orelapId == selectedLab"
                                          [orelapId]="lab.orelapId"
                                          [labName]="lab.laboratoryName"> test </app-lab-applications>
                  </div>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                class="expansion-element-row"
                [class.expansion-expanded-row]="expandedElement == row"
                (click)="rowclick(row)"
                ></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expansion-detail-row"></tr>

          </table>
        </div>
      </div>
      <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                     #ApplicationPaginator="matPaginator"
                     showFirstLastButtons></mat-paginator>
    </div>

    <app-lab-applications *ngIf="labs.length === 1"
                          [orelapId]="labs[0].orelapId"
                          [labName]="labs[0].laboratoryName"></app-lab-applications>

  </mat-card-content>
</mat-card>


